import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import {ColumnTableItem, Currency} from '../../../global';
import { NgIf, NgFor, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { AccessDirective } from '../../directives/has-access.directive';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { MatTooltip } from '@angular/material/tooltip';
import { LoaderComponent } from '../loader/loader.component';
import { ButtonIconComponent } from '../buttons/button-icon/button-icon.component';
import { CurrencyTransformPipe } from '../../pipes/currency-transform.pipe';
import { DateTransformPipe } from '../../pipes/date-transform.pipe';

@Component({
    selector: 'slm-simple-table',
    templateUrl: './simple-table.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgFor, NgSwitch, AccessDirective, NgSwitchCase, TranslateDirective, SvgIconComponent, MatTooltip, LoaderComponent, ButtonIconComponent, NgSwitchDefault, TranslatePipe, CurrencyTransformPipe, DateTransformPipe]
})
export class SimpleTableComponent {
  @Input() public config: Array<ColumnTableItem> = [];
  @Input() public items: Array<any> = [];
  @Input() public currency: Currency = null;
  @Output() public clicked = new EventEmitter<any>();
  @Input() public extraAttributeName: string;

  buttonClicked(item: any, action: any) {
    this.clicked.emit({...item, action});
  }
}
